import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
export const HomeSwitch = (param)=>{
    let { value , onChange , className  } = param;
    const teacherRef = useRef(null);
    const studentRef = useRef(null);
    const [dimensions, setDimensions] = useState({
        teacherWidth: 0,
        studentWidth: 0
    });
    useEffect(()=>{
        if (teacherRef.current && studentRef.current) {
            setDimensions({
                teacherWidth: teacherRef.current.offsetWidth,
                studentWidth: studentRef.current.offsetWidth
            });
        }
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("relative flex items-center rounded-full bg-white", "shadow-[0_2px_8px_0_rgba(0,0,0,0.08),0_1px_4px_0_rgba(0,0,0,0.04)]", className),
        children: [
            /*#__PURE__*/ _jsx(motion.div, {
                className: "absolute inset-y-0 rounded-full bg-gray-700",
                initial: false,
                animate: {
                    x: value === "teacher" ? 0 : dimensions.teacherWidth,
                    width: value === "teacher" ? dimensions.teacherWidth : dimensions.studentWidth
                },
                transition: {
                    type: "spring",
                    stiffness: 500,
                    damping: 30
                }
            }),
            /*#__PURE__*/ _jsx("button", {
                ref: teacherRef,
                type: "button",
                onClick: ()=>onChange("teacher"),
                className: cn("typo-subtitle1 relative z-10 rounded-full px-3 py-1.5 transition-colors", value === "teacher" ? "text-white" : "text-gray-500"),
                children: "선생님"
            }),
            /*#__PURE__*/ _jsx("button", {
                ref: studentRef,
                type: "button",
                onClick: ()=>onChange("student"),
                className: cn("typo-subtitle1 relative z-10 rounded-full px-3 py-1.5 transition-colors", value === "student" ? "text-white" : "text-gray-500"),
                children: "학생"
            })
        ]
    });
};
